module.exports = __webpack_public_path__ + "img/skull_stroke.d4e25048.png";